import { useState } from 'react';

function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => {
        setValue(val => {
            return val + 1;
        });
    };
}

export default useForceUpdate;
